import { render, staticRenderFns } from "./BuyStat.vue?vue&type=template&id=280a7894&scoped=true&"
import script from "./BuyStat.vue?vue&type=script&lang=js&"
export * from "./BuyStat.vue?vue&type=script&lang=js&"
import style0 from "./BuyStat.vue?vue&type=style&index=0&id=280a7894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280a7894",
  null
  
)

export default component.exports